import { API_CONFIG, API_ENDPOINTS } from '../config/api';

interface UploadUrlResponse {
  resultType: string;
  result: {
    storageKey: string;
    uploadUrl: string;
    fields: Record<string, string>;
  };
}

async function getAuthHeaders() {
  const token = localStorage.getItem('accessToken');
  const userId = localStorage.getItem('userId');
  return {
    'Content-Type': 'application/json',
    ...(token && { Authorization: `Bearer ${token}` }),
    ...(userId && { KEY_USER_ID: userId }),
  };
}

export async function uploadAttachments(
  ownerType: 'REPORT' | 'INQUIRY' | 'INQUIRY_COMMENT' | 'APPEAL',
  ownerId: number,
  files: File[]
): Promise<void> {
  if (!files || files.length === 0) return;

  const headers = await getAuthHeaders();

  for (const file of files) {
    // Step 1: Get presigned URL
    const urlRes = await fetch(`${API_CONFIG.baseURL}${API_ENDPOINTS.ATTACHMENT.UPLOAD_URL}`, {
      method: 'POST',
      headers,
      credentials: 'include',
      body: JSON.stringify({
        ownerType,
        ownerId,
        fileName: file.name,
        contentType: file.type || 'application/octet-stream',
      }),
    });

    if (!urlRes.ok) {
      const err = await urlRes.json().catch(() => ({}));
      throw new Error(err?.error?.message ?? 'Presigned URL 발급에 실패했습니다.');
    }

    const urlData: UploadUrlResponse = await urlRes.json();
    const { storageKey, uploadUrl, fields } = urlData.result;

    // Step 2: Upload to S3
    const formData = new FormData();
    Object.entries(fields).forEach(([k, v]) => formData.append(k, v));
    formData.append('file', file); // file은 반드시 마지막에 append

    const s3Res = await fetch(uploadUrl, {
      method: 'POST',
      body: formData,
    });

    if (!s3Res.ok && s3Res.status !== 204) {
      throw new Error('S3 업로드에 실패했습니다.');
    }

    // Step 3: Register in DB
    const regRes = await fetch(`${API_CONFIG.baseURL}${API_ENDPOINTS.ATTACHMENT.REGISTER}`, {
      method: 'POST',
      headers,
      credentials: 'include',
      body: JSON.stringify({
        ownerType,
        ownerId,
        storageKey,
        mimeType: file.type || 'application/octet-stream',
        fileSize: file.size,
      }),
    });

    if (!regRes.ok) {
      const err = await regRes.json().catch(() => ({}));
      throw new Error(err?.error?.message ?? '첨부파일 등록에 실패했습니다.');
    }
  }
}
